export default {
  title: 'Changement d\'email',
  warning: {
    title: 'Oups',
    text: 'Il semble qu\'il y a eu un problème lors du changement d\'adresse email',
  },
  success: {
    title: 'Votre email a été changé',
    text: 'Le changement de votre adresse email a bien été pris en compte',
  },
  link: 'Retourner sur la page d\'accueil',
};
